import { AppState } from '~src/app/state/AppState';

import { Messages } from '../../codegen/Localize';
import { EntityActionNames, IEntityAction } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { IRunFlowAction } from '../../ts/ServerApi/types/actionNames';
import { runFlow } from '../actions/RunFlowReduxAction';

export const RunFlowEntityAction: IEntityAction<IContentInfo<'flow'>, IRunFlowAction> = {
  name: EntityActionNames.RunNow,
  translateName: Messages.runNow,
  isVisible: () => true,
  isClickable: (availableActions: IRunFlowAction, _targetItems: IContentInfo<'flow'>[], state: AppState) => {
    return !!(availableActions && availableActions.runFlow);
  },
  createReduxAction: (targetItems: IContentInfo[]) => runFlow(targetItems)
};
